"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _rebrand = require("../../icons-react/rebrand");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SuccessIcon = function SuccessIcon(_ref) {
  var _ref$classname = _ref.classname,
    classname = _ref$classname === void 0 ? '' : _ref$classname,
    _ref$success = _ref.success,
    success = _ref$success === void 0 ? true : _ref$success,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 60 : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: classname,
    $size: size,
    $success: success
  }, success ? /*#__PURE__*/_react["default"].createElement(_rebrand.DoneMark, null) : /*#__PURE__*/_react["default"].createElement(CrossMark, null));
};
var CrossMark = (0, _styledComponents["default"])(_rebrand.XMark).withConfig({
  displayName: "SuccessIcon__CrossMark",
  componentId: "sc-1o3ll7c-0"
})(["path{fill:var(--secondary);}"]);
var Container = _styledComponents["default"].div.withConfig({
  displayName: "SuccessIcon__Container",
  componentId: "sc-1o3ll7c-1"
})(["padding:8px;min-width:15px;min-height:15px;border-radius:100%;display:inline-flex;justify-content:center;align-items:center;", ";background-color:", ";"], function (_ref2) {
  var $size = _ref2.$size;
  return (0, _styledComponents.css)(["width:", "px;height:", "px;"], $size, $size);
}, function (_ref3) {
  var $success = _ref3.$success;
  return $success ? (0, _styledComponents.css)(["var(--primary)"]) : (0, _styledComponents.css)(["var(--background)"]);
});
var _default = exports["default"] = SuccessIcon;